import '~/assets/scss/sro.scss'


import Form from '~/js/modules/form';
import getSwiperSlider from '~/js/modules/slider';

window.addEventListener(`DOMContentLoaded`, () => {
  const forms = document.querySelectorAll(`.js-form-b`);

  if (forms.length) {
    forms.forEach((form) => new Form(form));
  }
});
